export const htmlToText = (value?: string): string => {
  return value ? value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ') : '';
};
